import { render, staticRenderFns } from "./WriteBatchShipping.vue?vue&type=template&id=16c56a77"
import script from "./WriteBatchShipping.vue?vue&type=script&lang=js"
export * from "./WriteBatchShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports